import React from "react";
import {
  DashboardStock
} from "../../_metronic/_partials";

export function StockReportPage() {
  return <DashboardStock />;
}
